__turbopack_context__.v({
  "checkboxBox": "support-contact-form-module__-g1Gzq__checkboxBox",
  "checkboxContainer": "support-contact-form-module__-g1Gzq__checkboxContainer",
  "checkboxContainerNew": "support-contact-form-module__-g1Gzq__checkboxContainerNew",
  "checkboxLabel": "support-contact-form-module__-g1Gzq__checkboxLabel",
  "checkboxWrapper": "support-contact-form-module__-g1Gzq__checkboxWrapper",
  "comboboxButton": "support-contact-form-module__-g1Gzq__comboboxButton",
  "comboboxWrapper": "support-contact-form-module__-g1Gzq__comboboxWrapper",
  "error": "support-contact-form-module__-g1Gzq__error",
  "fieldGroup": "support-contact-form-module__-g1Gzq__fieldGroup",
  "form": "support-contact-form-module__-g1Gzq__form",
  "formContainer": "support-contact-form-module__-g1Gzq__formContainer",
  "grid": "support-contact-form-module__-g1Gzq__grid",
  "headerEmailIcon": "support-contact-form-module__-g1Gzq__headerEmailIcon",
  "headerEmailLink": "support-contact-form-module__-g1Gzq__headerEmailLink",
  "headerEmailRow": "support-contact-form-module__-g1Gzq__headerEmailRow",
  "heading": "support-contact-form-module__-g1Gzq__heading",
  "headingContainer": "support-contact-form-module__-g1Gzq__headingContainer",
  "input": "support-contact-form-module__-g1Gzq__input",
  "inputError": "support-contact-form-module__-g1Gzq__inputError",
  "label": "support-contact-form-module__-g1Gzq__label",
  "lastRow": "support-contact-form-module__-g1Gzq__lastRow",
  "listbox": "support-contact-form-module__-g1Gzq__listbox",
  "listboxItem": "support-contact-form-module__-g1Gzq__listboxItem",
  "optional": "support-contact-form-module__-g1Gzq__optional",
  "popover": "support-contact-form-module__-g1Gzq__popover",
  "recaptchaWrapper": "support-contact-form-module__-g1Gzq__recaptchaWrapper",
  "required": "support-contact-form-module__-g1Gzq__required",
  "row": "support-contact-form-module__-g1Gzq__row",
  "rowEqualHeight": "support-contact-form-module__-g1Gzq__rowEqualHeight",
  "slideIn": "support-contact-form-module__-g1Gzq__slideIn",
  "statusError": "support-contact-form-module__-g1Gzq__statusError",
  "statusMessage": "support-contact-form-module__-g1Gzq__statusMessage",
  "statusSuccess": "support-contact-form-module__-g1Gzq__statusSuccess",
  "submitButton": "support-contact-form-module__-g1Gzq__submitButton",
  "submitWrapper": "support-contact-form-module__-g1Gzq__submitWrapper",
  "submitWrapperDesktop": "support-contact-form-module__-g1Gzq__submitWrapperDesktop",
  "submitWrapperMobile": "support-contact-form-module__-g1Gzq__submitWrapperMobile",
  "successActions": "support-contact-form-module__-g1Gzq__successActions",
  "successContainer": "support-contact-form-module__-g1Gzq__successContainer",
  "successContent": "support-contact-form-module__-g1Gzq__successContent",
  "successIcon": "support-contact-form-module__-g1Gzq__successIcon",
  "successMessage": "support-contact-form-module__-g1Gzq__successMessage",
  "textarea": "support-contact-form-module__-g1Gzq__textarea",
});
